import type { JSX } from 'solid-js';
import { ModeMenu } from '@ui/Modes/ModeMenu';
import './Shell.css';

export function Shell(props: { children?: JSX.Element }) {
  return (
    <div class="shell">
      <aside class="shell__aside">
        <div class="shell__brand">
          <img
            class="shell__logo"
            src="/brand/logo/octopus-logo-512.png?v=gold3"
            width="40"
            height="40"
            alt=""
          />
          <div>
            <h1 class="shell__title">OctoDojo</h1>
            <p class="shell__tagline">Play. Notice. Learn.</p>
          </div>
        </div>
        <ModeMenu />
      </aside>

      <main class="shell__main">{props.children}</main>
    </div>
  );
}
